import { FirebaseError } from '@firebase/util'
import { BodyFastAction } from '.'
import { ActionType } from './ActionTypes'
import { PromoCodeBenefit, PromoCodeValidationError } from 'types/uscTypes'

export interface UscState {
  /** Code that passed the pre-check, kept until it is redeemed after sign-in */
  validatedCode: string | null
  benefit: PromoCodeBenefit | null
  /**
   * Translation key for a redemption that was refused after sign-in. The account
   * screen is gone by then (its code is dropped), so the reason travels here and
   * is shown — and consumed — by the code entry screen.
   */
  redeemErrorKey: string | null
}

export interface IUscSubmitCodeAction { type: ActionType.USC_SUBMIT_CODE, code: string, resolve: () => void, reject: (error: PromoCodeValidationError | Error) => void }
export interface IUscSetValidatedCodeAction { type: ActionType.USC_SET_VALIDATED_CODE, code: string | null, benefit: PromoCodeBenefit | null }
export interface IUscSetRedeemErrorAction { type: ActionType.USC_SET_REDEEM_ERROR, errorKey: string | null }
export interface IUscSignInAndRedeemAction { type: ActionType.USC_SIGN_IN_AND_REDEEM, email: string, password: string, reject: (error: FirebaseError | Error) => void }
export interface IUscRegisterAndRedeemAction { type: ActionType.USC_REGISTER_AND_REDEEM, name: string, email: string, password: string, reject: (error: FirebaseError | Error) => void }
/** `onCancel` fires when the member closes the provider popup — nothing failed, so the screen just stops waiting. */
export interface IUscSocialSignInAndRedeemAction { type: ActionType.USC_SOCIAL_SIGN_IN_AND_REDEEM, provider: UscSocialProvider, reject: (error: FirebaseError | Error) => void, onCancel: () => void }

export type UscSocialProvider = 'google' | 'apple'

export type UscAction =
  | IUscSubmitCodeAction
  | IUscSetValidatedCodeAction
  | IUscSetRedeemErrorAction
  | IUscSignInAndRedeemAction
  | IUscRegisterAndRedeemAction
  | IUscSocialSignInAndRedeemAction

const INITIAL_STATE: UscState = {
  validatedCode: null,
  benefit: null,
  redeemErrorKey: null
}

export const UscReducer = (state: UscState = INITIAL_STATE, action: BodyFastAction): UscState => {
  switch (action.type) {
    case ActionType.USC_SET_VALIDATED_CODE: {
      return { ...state, validatedCode: action.code, benefit: action.benefit }
    }
    case ActionType.USC_SET_REDEEM_ERROR: {
      return { ...state, redeemErrorKey: action.errorKey }
    }
    default:
      return state
  }
}
